"use strict";

exports.__esModule = true;
/*eslint-disable */

function Event(name) {
  this.name = name;
  this.callbacks = [];
}

Event.prototype.registerCallback = function (callback) {
  this.callbacks.push(callback);
};

Event.prototype.unregisterCallback = function (callback) {
  this.callbacks = this.callbacks.reduce(function (prev, next) {
    if (next !== callback) {
      prev.push(next);
    }

    return prev;
  }, []);
};

function EventManager() {
  this.events = {};
}

EventManager.prototype.registerEvent = function (eventName) {
  var event = new Event(eventName);
  this.events[eventName] = event;
};

EventManager.prototype.dispatchEvent = function (eventName) {
  for (var _len = arguments.length, eventArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    eventArgs[_key - 1] = arguments[_key];
  }

  this.events[eventName].callbacks.forEach(function (callback) {
    callback.apply(undefined, eventArgs);
  });
};

EventManager.prototype.addEventListener = function (eventName, callback) {
  this.events[eventName].registerCallback(callback);
};

EventManager.prototype.removeEventListener = function (eventName, callback) {
  this.events[eventName].unregisterCallback(callback);
};

EventManager.prototype.clearEventListeners = function () {
  for (var event in this.events) {
    this.events[event].callbacks = [];
  }
};

var eventManager = new EventManager();

exports.default = eventManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/event-manager/event-manager.js
// module id = 179
// module chunks = 0